import { AssignableRecipient, Piece, PieceAction, User, UserMin } from '@apiContract';
import { isAssignableRecipient } from '@utils/recipient';

import { AddEvent } from './useUpdateQueue';
import { useMe } from '@hooks/useMe';

export const useAssignmentRecipient = (addEvent: (param: AddEvent) => void) => {
  const { currentUser } = useMe();

  const getRecipientIds = (user: AssignableRecipient | User | UserMin) => {
    if (isAssignableRecipient(user)) {
      if (user.groupId && !user.userId) {
        return { recipientId: null, recipientGroupId: user.groupId };
      }
      return { recipientId: user.userId, recipientGroupId: null };
    }
    return { recipientId: user.id, recipientGroupId: null };
  };

  const assignRecipientToPiece = (user: AssignableRecipient | User | UserMin, piece: Piece) => {
    if (!currentUser || !piece) return;

    addEvent({
      event: {
        id: piece.id,
        ...getRecipientIds(user),
      },
      action: PieceAction.Assign,
      source: 'user',
    });
  };
  return { assignRecipientToPiece };
};
